import React, { useEffect, useState } from "react";
import axios from "axios";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { useFm, fmtKg, fmtInt, fmtDate, Bars } from "./biShared";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BiProductDetail({ product, filters, onClose }) {
  const fm = useFm();
  const [d, setD] = useState(null);
  useEffect(() => {
    if (!product) { setD(null); return; }
    setD(null);
    axios.get(`${API}/admin/bi/product/${encodeURIComponent(product.code)}`, { params: filters }).then((r) => setD(r.data)).catch(() => setD({ error: true }));
  }, [product, filters]);

  return (
    <Dialog open={!!product} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl max-h-[92vh] overflow-y-auto" data-testid="bi-product-detail">
        <DialogHeader>
          <DialogTitle className="text-base sm:text-lg leading-tight">{d?.description || product?.description || product?.code}</DialogTitle>
          <p className="text-xs text-stone-500 font-mono">{product?.code}</p>
        </DialogHeader>
        {!d && <p className="text-sm text-stone-500 py-6 text-center">Caricamento…</p>}
        {d?.error && <p className="text-sm text-red-700 py-6 text-center">Dettaglio non disponibile</p>}
        {d && !d.error && (
          <div className="space-y-5">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
              {[["Fatturato (imponibile)", fm(d.totals.revenue), `IVA inclusa ${fm(d.totals.revenue_gross)}`], ["Kg", `${fmtKg(d.totals.kg, 1)} kg`], ["Prezzo medio", d.totals.avg_price_kg != null ? `${fm(d.totals.avg_price_kg)}/kg` : "—"], ["DDT / clienti", `${fmtInt(d.totals.ddt_count)} / ${fmtInt(d.totals.customers)}`]].map(([l, v, x]) => (
                <div key={l} className="bg-stone-50 rounded-xl p-3">
                  <p className="text-[11px] uppercase tracking-wide text-stone-500 font-semibold">{l}</p>
                  <p className="text-lg font-bold text-stone-900 tabular-nums">{v}</p>
                  {x && <p className="text-[11px] text-stone-500 tabular-nums">{x}</p>}
                </div>
              ))}
            </div>
            <p className="text-[11px] text-stone-500">Periodo {fmtDate(d.period.from)} – {fmtDate(d.period.to)}. {d.notes}</p>
            <section>
              <h4 className="font-semibold text-stone-900 mb-2">Clienti nel periodo</h4>
              {!d.by_customer.length && <p className="text-sm text-stone-500 italic">Nessun cliente</p>}
              <div className="divide-y divide-stone-100">
                {d.by_customer.map((c) => (
                  <div key={c.key} className="flex items-center justify-between gap-3 py-2.5 min-h-[52px]" data-testid={`bi-prod-cust-${c.key}`}>
                    <div className="min-w-0"><p className="font-medium text-stone-900 truncate">{c.name}</p><p className="text-[11px] text-stone-500">{fmtInt(c.ddt_count)} DDT · ultimo {fmtDate(c.last_date)} · {c.agent_name}</p></div>
                    <div className="text-right shrink-0"><p className="font-bold tabular-nums">{fm(c.revenue)}</p><p className="text-[11px] text-stone-500 tabular-nums">IVA incl. {fm(c.gross)}</p><p className="text-xs text-stone-600 tabular-nums">{fmtKg(c.kg, 1)} kg</p></div>
                  </div>
                ))}
              </div>
            </section>
            <section>
              <h4 className="font-semibold text-stone-900 mb-2">Ultimi 12 mesi <span className="text-xs font-normal text-stone-500">(kg)</span></h4>
              <Bars data={d.by_month} valueKey="kg" color="#B45309" formatValue={(v) => `${fmtKg(v, 0)} kg`} emptyLabel="Nessuna vendita negli ultimi 12 mesi" testIdPrefix="bi-prod-month" />
            </section>
            {d.by_lot.length > 0 && (
              <section>
                <h4 className="font-semibold text-stone-900 mb-2">Lotti nel periodo <span className="text-xs font-normal text-stone-500">({d.by_lot.length})</span></h4>
                <div className="flex flex-wrap gap-2">
                  {d.by_lot.map((l) => <span key={l.lot} className="text-xs bg-stone-100 rounded-lg px-2.5 py-1.5" data-testid={`bi-prod-lot-${l.lot}`}><b>{l.lot}</b> · {fmtKg(l.kg, 1)} kg · {fmtInt(l.ddt_count)} DDT</span>)}
                </div>
              </section>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
